import { Component, Inject, OnInit } from '@angular/core';
import { LandFinanceObject } from '../../../../../models/finance-document.model';
import { RestService } from '../../../../../service/rest.service';
import { forkJoin, Observable } from 'rxjs';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import * as fromRoot from '../../../../../store/reducers';
import { BaseAbstractFinanceObjectAdderComponent } from '../../base-abstract-finance-object-adder.component';


@Component({
  selector: 'app-finance-object-land-adder',
  templateUrl: './finance-object-land-adder.component.html',
  styleUrls: ['./finance-object-land-adder.component.scss']
})
export class FinanceObjectLandAdderComponent extends BaseAbstractFinanceObjectAdderComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<FinanceObjectLandAdderComponent>,
              protected restService: RestService,
              protected store: Store<fromRoot.AppState>,
              @Inject(MAT_DIALOG_DATA) public data: {object: LandFinanceObject, id: string}) {
    super(dialogRef, restService, store, data);
    this.type = 'land';
  }

  ngOnInit() {

    this.types$ = this.restService
      .getFinanceLandTypes()
      .pipe(
        this.pipeType()
      );

    this.names$ = this.restService
      .getFinanceLandNames()
      .pipe(
        this.pipeName()
      );

    this.addresses$ = this.restService
      .getFinanceLandAddresses()
      .pipe(
        this.pipeAddress()
      );

    this.data$ = forkJoin([this.types$, this.names$, this.addresses$]);

    super.ngOnInit();

  }

  saveData$(): Observable<any> {
    return (this.isAdd ?
        this.restService.addOneFinanceLand(this.idFinance, this.object) :
        this.restService.updateOneFinanceLand(this.objectId, this.object)
    );
  }

}
